import * as statuses from "./projectStore_Constants";
import jsonHelper from "../../shared/jsonHelper";

export default {
  checkForStatus(statusArray, statusName) {
    if (statusArray) {
      return statusArray.includes("," + statusName + ",");
    } else {
      return false;
    }
  },

  ensureStatus(statusArray, statusName, actionsList) {
    if (!this.checkForStatus(statusArray, statusName)) {
      statuses.REGOLE_ESCLUSIONE.forEach(regola => {
        if (regola[0] == statusName) {
          statusArray = this.removeStatus(statusArray, regola[1]);
          let action = this.actionsAfterStatusChange(statusName, regola[1]);
          if (action) {
            action.forEach(itm => actionsList.push(itm));
          }
        }
      });

      return statusArray + statusName + ",";
    } else {
      return statusArray;
    }
  },

  actionsAfterStatusChange(destStatus, prevStatus) {
    let result = null;
    statuses.REGOLE_AZIONI.forEach(regola => {
      if (regola[0] == destStatus && regola[1] == prevStatus) {
        result = regola[2];
      }
    });
    return result;
  },

  removeStatus(statusArray, statusName) {
    if (this.checkForStatus(statusArray, statusName)) {
      // RIMUOVI
      let newArr = statusArray.replace("," + statusName + ",", ",");
      if (newArr) {
        statusArray = newArr;
      }
    }
    return statusArray;
  },

  settaValoreView(store, projects, projectPath, elemento, valore, input, output, bilancio) {
    var el = projectPath + "." + elemento;
    if (input) {
      store.dispatch("changeProjectPropertyInternal", {
        path: el + ".input.usrValue.value",
        value: valore
      });
    }
    if (output) {
      store.dispatch("changeProjectPropertyInternal", {
        path: el + ".output.refValue.value",
        value: valore
      });
    }
    if (bilancio) {
      store.dispatch("changeProjectPropertyInternal", {
        path: el + ".outputBilancio.refValue.value",
        value: valore
      });
    }
  },

  settaValore(projects, projectPath, elemento, valore, input, output, bilancio) {
    var el = projectPath + "." + elemento;
    if (input) {
      this.settaValoreUM(projects, el + ".input.refValue.value", valore);
      this.settaValoreUM(projects, el + ".input.usrValue.value", valore);
    }
    if (output) {
      this.settaValoreUM(projects, el + ".output.refValue.value", valore);
      this.settaValoreUM(projects, el + ".output.usrValue.value", valore);
    }
    if (bilancio) {
      this.settaValoreUM(projects, el + ".outputBilancio.usrValue.value", valore);
      this.settaValoreUM(projects, el + ".outputBilancio.refValue.value", valore);
    }
  },

  settaValoreDiretto(projects, projectPath, elemento, valore) {
    // var that = this;
    var el = projectPath + "." + elemento;
    jsonHelper.setProperty(projects, el, valore);
  },

  settaOutputAndBalanceToNull(projects, projectPath, elemento) {
    this.settaValoreDiretto(projects, projectPath, elemento + ".output.refValue.value", 0);
    this.settaValoreDiretto(projects, projectPath, elemento + ".output.usrValue.value", null);
    this.settaValoreDiretto(projects, projectPath, elemento + ".outputBilancio.refValue.value", 0);
    this.settaValoreDiretto(
      projects,
      projectPath,
      elemento + ".outputBilancio.usrValue.value",
      null
    );
  },

  settaValoreUM(projects, elementoUM, valore) {
    jsonHelper.setProperty(projects, elementoUM, valore);
  },

  leggiValoreDiretto(projects, projectPath, elemento) {
    var value = jsonHelper.getProperty(projects, projectPath + "." + elemento);
    return value;
  }
};
